import React, { useState, useEffect, useCallback } from 'react';
import { Navbar }       from './components/Navbar';
import { ToastContainer, useToast } from './components/Toast';
import { AuthPage }     from './pages/AuthPage';
import { WalletsPage }  from './pages/WalletsPage';
import { RulesPage }    from './pages/RulesPage';
import { ActivityPage } from './pages/ActivityPage';
import { SettingsPage } from './pages/SettingsPage';
import { api }          from './utils/api';

const PAGES = {
  wallets:  WalletsPage,
  rules:    RulesPage,
  activity: ActivityPage,
  settings: SettingsPage,
};

export default function App() {
  const [active, setActive]   = useState('wallets');
  const [health, setHealth]   = useState(false);
  const [user,   setUser]     = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });
  const { toasts, toast, remove } = useToast();

  const checkHealth = useCallback(async () => {
    try { await api.health(); setHealth(true); }
    catch  { setHealth(false); }
  }, []);

  useEffect(() => {
    checkHealth();
    const id = setInterval(checkHealth, 30_000);
    return () => clearInterval(id);
  }, [checkHealth]);

  const handleLogin = (userData, token) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setActive('wallets');
  };

  // Not logged in — show auth page
  if (!user) {
    return (
      <>
        <AuthPage onLogin={handleLogin} />
        <ToastContainer toasts={toasts} remove={remove} />
      </>
    );
  }

  const Page = PAGES[active];

  return (
    <div style={{ minHeight:'100vh' }}>
      <Navbar active={active} setActive={setActive} health={health} user={user} />
      <main style={S.main}>
        <Page toast={toast} user={user} onLogout={handleLogout} />
      </main>
      <ToastContainer toasts={toasts} remove={remove} />
    </div>
  );
}

const S = {
  main: { maxWidth:1100, margin:'0 auto', padding:'32px 24px' },
};
